import {CompleteTaskSuccessParams, Task} from '@buncha/config/onfleet/types';

export const verifyOnfleetCompleteParams = (
  task: Task,
  params: CompleteTaskSuccessParams,
) => {
  if (
    task.barcodes &&
    task.barcodes?.findIndex(
      barcode =>
        barcode.blockCompletion &&
        params.barcodes?.findIndex(b => b.data === barcode.data) === -1,
    ) !== -1
  )
    return 'Scan all barcodes';
  if (task.notesRequired && !params.notes?.length) return 'Notes required';
  if (task.photoRequired && !params.photos?.length) return 'Photo required';
  if (task.signatureRequired && !params.signatureDetails?.name?.length)
    return 'Signature required';
  if (task?.minimumAge && !params?.ageDetails) return 'Verify Age';
  if (
    task?.minimumAge &&
    params?.ageDetails &&
    !params?.ageDetails?.dateOfBirth
  )
    return 'Please use valid id proof';
  return null;
};

export const camelToFlat = (camel: string) => {
  const camelCase = camel.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');

  let flat = '';

  camelCase.forEach(word => {
    flat = flat + word.charAt(0).toUpperCase() + word.slice(1) + ' ';
  });
  return flat;
};

export const doubleDecimalOnlyRegex = /[.,]00$/;

export function isValidLatLong(latitude: number, longitude: number) {
  if (typeof latitude !== 'number' || typeof longitude !== 'number')
    return false;

  const isLatValid = latitude >= -90 && latitude <= 90;
  const isLongValid = longitude >= -180 && longitude <= 180;
  return isLatValid && isLongValid;
}

export function splitAtFirstComma(str: string) {
  const index = str.indexOf(',');
  if (index === -1) return [str, ''];

  return [str.substring(0, index), str.substring(index + 1).trim()];
}
